import React from "react";
import { SelectAndSearch } from "../../../../../components/ui/Form/SelectAndSearch";
import { DateFilters } from "../../../../../components/ui/Form/Period";
import _Button from "../../../../../components/generic/_Button";
import DataReportByPartners from "./DataReportByPartners";
import { useRCSReportByPartners } from "../hooks/useRCSReportByPartners";
import { useGetPartners } from "../hooks/useGetPartners";
const ReportByPartners = () => {
  const { formik, reset, isLoading, _validate, handleReset, data } =
    useRCSReportByPartners();

  const { data: partnerList } = useGetPartners();

  return (
    <div className="flex flex-col">
      <div className="bg-white rounded-lg p-3">
        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-2 ">
          <SelectAndSearch
            handleChange={(e) => {
              formik.setFieldValue("partner", e);
            }}
            values={formik.values.partner}
            options={partnerList.map((partner) => ({
              value: partner.uidpartner,
              label: partner.name,
            }))}
            placeholder="Selecciona un partner"
            errors={
              formik.errors && formik.errors.partner
                ? formik.errors.partner
                : ""
            }
            isError={formik.errors && formik.errors.partner}
            title="Partner"
            required
            onReset={reset}
          />
          <DateFilters
            required
            setFilterFrom={(e) => formik.setFieldValue("period.dateFrom", e)}
            setFilterTo={(e) => formik.setFieldValue("period.dateTo", e)}
            errors={formik.errors}
            isClean={formik.values.period.dateFrom === ""}
          />
        </div>

        <div className="gap-2 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-2">
          <_Button
            icon="clear_all"
            onClick={handleReset}
            disabled={isLoading}
            loading={isLoading}
            style="none"
            title="Limpiar"
            className="w-full"
          />
          <_Button
            icon="analytics"
            style="primary"
            onClick={async () => await _validate()}
            title="Generar Reporte"
            className="w-full"
          />
        </div>
      </div>

      <DataReportByPartners isLoading={isLoading} data={data} />
    </div>
  );
};

export default ReportByPartners;
